
const requestTypes = {
    question: "QUESTION",
    problem: "PROBLEM",
    suggestion: "SUGGESTION",
    request: "REQUEST",
    other: "OTHER"
}

const requestTypeOptions = [
    { id: requestTypes.problem, name: "נראה לי שיש בעיה במערכת" },
    { id: requestTypes.question, name: "יש לי שאלה" },
    { id: requestTypes.suggestion, name: "אני רוצה להציע" },
    { id: requestTypes.request, name: "אני רוצה לבקש" },
    { id: requestTypes.other, name: "משהו אחר" },
]

export { requestTypeOptions }
export default requestTypes